import { useCallback } from "react";
import { isFunction, isNil } from "./assertions";
export function assignRef(ref, node) {
  if (!isNil(ref)) {
    if (isFunction(ref)) {
      ref(node);
    } else {
      ref.current = node;
    }
  }
}
export function mergeRefs(...refs) {
  const mergedRef = current => {
    mergedRef.current = current;
    refs.filter(Boolean).forEach(ref => {
      assignRef(ref, current);
    });
  };

  return mergedRef;
}
export function useMergedRefs(...refs) {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  return useCallback(mergeRefs(...refs), refs);
}